import InfoMainList from './InfoMainList';
export default InfoMainList;